import React, { memo } from 'react';

import SeoTextsBlocks from 'components/SeoTextsBlocks';
import SeoMetaTextBlock from 'components/SeoMetaTextBlock';
import { BanksPageBreadCrumbs } from 'components/BanksPageBreadCrumbs';
import Banner from 'components/Banner';

import { BreadCrumbsWrapper } from 'components/FooterStyles';

import { Wrapper } from './styles';

const BanksPageFooter = memo(() => (
  <Wrapper>
    <SeoMetaTextBlock />
    <SeoTextsBlocks />

    <BreadCrumbsWrapper>
      <BanksPageBreadCrumbs />
      <Banner id="rp-react-banner-catfish" slot="bn-slot-catfish" />
    </BreadCrumbsWrapper>
  </Wrapper>
));

export default BanksPageFooter;
